import { useDisclose } from 'hooks/utilHooks';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Collapse,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';

interface Props {
  createdAt: string;
  discounts: {
    discountValue: number;
    text: string;
    _id?: string;
  }[];
}

export const PartnerDiscountRow: React.FC<Props> = ({
  discounts,
  createdAt,
}) => {
  const { isOpen, onToggle } = useDisclose();

  const border =
    discounts?.length > 1 ? 'hidden' : '1px solid rgba(0, 0, 0, 0.12)';

  return (
    <>
      {discounts?.map((item, index) => {
        return (
          <>
            {index < 1 ? (
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    paddingY: 1,
                    borderBottom: border,
                    width: 104,
                  }}
                >
                  {item.discountValue}
                </TableCell>
                <TableCell
                  sx={{
                    paddingY: 1,
                    borderBottom: border,
                  }}
                >
                  {item.text}
                </TableCell>
                <TableCell
                  sx={{
                    paddingY: 1,
                    borderBottom: border,
                    width: 160,
                  }}
                >
                  <Grid item alignItems="center" wrap="nowrap">
                    {createdAt}
                    {discounts.length > 1 && (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        sx={{ marginLeft: 2 }}
                        onClick={onToggle}
                      >
                        {isOpen ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    )}
                  </Grid>
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell
                  style={{
                    paddingBottom: 0,
                    paddingTop: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    borderBottom: discounts[index + 1]
                      ? 'hidden'
                      : '1px solid rgba(0, 0, 0, 0.12)',
                  }}
                  colSpan={3}
                >
                  <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <Divider sx={{ width: 12 }} />

                    <Table size="small" stickyHeader aria-label="more-info">
                      <TableBody>
                        <TableRow>
                          <TableCell
                            sx={{
                              paddingTop: 0,
                              paddingLeft: 0,
                              paddingRight: 0,
                              borderBottom: 'hidden',
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                borderBottom: 'hidden',
                                width: 104,
                              }}
                            >
                              {item.discountValue}
                            </TableCell>
                            <TableCell
                              sx={{
                                borderBottom: 'hidden',
                              }}
                            >
                              {item.text}
                            </TableCell>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Collapse>
                </TableCell>
              </TableRow>
            )}
          </>
        );
      })}
    </>
  );
};

